export default __webpack_public_path__ + "static/media/Prototype.b9848da0.svg";